<template>
  <div id="app" class="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
   beforeMount() {
    if (typeof localStorage.getItem("token") == "string") this.getUser();
  },
  methods: {
 
    getUser() {
      axios({
        method: "POST",
        url: "/admin/me",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$store.commit("userData", response.data.data);
            this.$store.commit("userType", response.data.userdata.user.role);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
}

</script>

<style lang="scss">
@import "../sass/main.scss";

body {
  height: 100%;
   overflow-x:hidden!important;

  #app {
    height: 100%;
  }
}
</style>
